'use strict';

var defaults = require('lodash/defaults');

var clone = require('lodash/clone');

var get = require('lodash/get');

var defaultDuration = 60000;
var defaultType = 'default';

function getFromCache(key) {
  var cached = localStorage.getItem(key);
  var parse = JSON.parse(cached);
  var rep = parse.rep,
      times = parse.times;
  var reponse = new Response(new Blob([rep]));
  return {
    reponse: reponse,
    times: times,
    rep: rep
  };
}

function setFromCache(key, value) {
  localStorage.setItem(key, JSON.stringify({
    rep: value,
    times: new Date().getTime()
  }));
}

function urlApiRequest(_ref) {
  var body = _ref.body,
      credentials = _ref.credentials,
      method = _ref.method,
      redirect = _ref.redirect,
      url = _ref.url,
      _ref$context = _ref.context,
      context = _ref$context === undefined ? {} : _ref$context,
      type = _ref.type,
      _ref$headers = _ref.headers,
      headers = _ref$headers === undefined ? {} : _ref$headers,
      key = _ref.key;
  var headersAPI = headers;

  if (context.loginToken) {
    headersAPI.Authorization = 'Bearer ' + context.loginToken;
  }

  var apiKey = context.apiKEY || get(window, 'Meteor.settings.public.apiKey', process.env.REACT_APP_API_KEY);
  if (apiKey) headersAPI['X-Api-Key'] = apiKey;
  var options = {
    body: body,
    credentials: credentials,
    method: method,
    redirect: redirect,
    headers: headersAPI,
    key: key
  };
  var request = new Request(url, options);
  request.type = type;
  request.key = key;
  return request;
}

function cachingFetch(optionsI, init) {
  try {
    var options = clone(optionsI);
    defaults(options, {
      key: init.key || init.url,
      duration: defaultDuration,
      type: defaultType
    });
    var req = new Request(init, options);
    var cached = localStorage.getItem(options.key);
    var type = ['POST', 'PUT', 'PATCH', 'DELETE'].includes(init.method) ? 'no-store' : init.type || options.type;

    switch (type) {
      case 'force-cache':
        if (cached !== null) {
          var x = getFromCache(options.key);
          return Promise.resolve(x.reponse);
        }

        return fetch(req).then(function (response) {
          if (response.status < 200 && response.status > 299) return response;
          response.clone().text().then(function (x) {
            setFromCache(options.key, x);
          });
          return response;
        });

      case 'reload':
        return fetch(req).then(function (response) {
          if (response.status < 200 && response.status > 299) return response;
          response.clone().text().then(function (x) {
            setFromCache(options.key, x);
          });
          return response;
        });

      case 'no-store':
        return fetch(req).then(function (response) {
          return response;
        });

      default:
        if (cached !== null) {
          var val = getFromCache(options.key);
          var now = new Date().getTime();

          if (now < val.times + options.duration) {
            return Promise.resolve(val.reponse);
          }

          return fetch(req).then(function (response) {
            return response.clone().text().then(function (x) {
              if (response.status < 200 && response.status > 299) return response;

              if (val.rep === x) {
                return Promise.resolve(val.reponse);
              }

              localStorage.removeItem(options.key);
              setFromCache(options.key, x);
              return response;
            });
          });
        }

        return fetch(req).then(function (response) {
          if (response.status < 200 && response.status > 299) return response;
          response.clone().text().then(function (x) {
            setFromCache(options.key, x);
          });
          return response;
        });
    }
  } catch (error) {
    return error;
  }
}

function CrowdaaAPI() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      duration = _ref2.duration,
      type = _ref2.type,
      key = _ref2.key;

  return {
    fetch: cachingFetch.bind(this, {
      duration: duration,
      type: type,
      key: key
    }),
    buildRequest: urlApiRequest
  };
}

module.exports = CrowdaaAPI;